// extracted by mini-css-extract-plugin
export default {"loginBtn":"Button_loginBtn__B6HNM","btn":"Button_btn__L1Bw2","primary":"Button_primary__6WNSr"};